import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Datepicker
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, FormCheckbox, FormInput, Icon, Label, Table } from 'semantic-ui-react';

// Actions
import { setContractData, doContractAction } from "./contractSlice";

// Styles
import './contract.css';


//
registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @param {bool} editMode
 * @param {bool} additional
 * @returns 
 */
const Max2ContractHeadOfficeArrivals = ({ editMode, additional = false  }) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const Arrivals = additional ? Contract.ArrivalsUS : Contract.Arrivals;

  // Edit mode?
  const readOnly = editMode ? false : true;



  /**
   * 
   * @param {bool} headoffice 
   */
  const handleAddNewRow = (headoffice = false) => {
    dispatch(doContractAction({target: 'Arrivals.addRow', value: headoffice}))
  }



  /**
   * 
   */
  const handleDeleteRow = (rowIndex) => {
    dispatch(doContractAction({target: 'Arrivals.deleteRow', value: rowIndex}))
  }



  /**
   * 
   */
  const handleCopyRow = (rowIndex) => {
    dispatch(doContractAction({target: 'Arrivals.copyRow', value: rowIndex}))
  }
  
  // If no records
  if (typeof Arrivals === 'undefined' || !Arrivals || !Arrivals.length) {
    return (
      <> 
      {!readOnly && (
        <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
          <Icon name='plus' />
          Zeile hinzufügen (HeadOffice)
        </Button>
      )}
      </>
    );
  }

  return (
    <>
    <Table celled structured striped basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell></Table.HeaderCell>
          <Table.HeaderCell>von</Table.HeaderCell>
          <Table.HeaderCell>bis</Table.HeaderCell>
          <Table.HeaderCell>Mo</Table.HeaderCell>
          <Table.HeaderCell>Di</Table.HeaderCell>
          <Table.HeaderCell>Mi</Table.HeaderCell>
          <Table.HeaderCell>Do</Table.HeaderCell>
          <Table.HeaderCell>Fr</Table.HeaderCell>
          <Table.HeaderCell>Sa</Table.HeaderCell>
          <Table.HeaderCell>So</Table.HeaderCell>
          {!readOnly && (
            <Table.HeaderCell></Table.HeaderCell>
          )}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Arrivals.map((arrival, arrivalKey)=>(
          <Table.Row key={arrivalKey}>
            <Table.Cell>
              {!arrival.Additional && (<Label as='a' color='red' ribbon>HeadOffice</Label>)}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(arrival.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  selected={arrival.Start}
                  startDate={arrival.Start}
                  endDate={arrival.End}
                  dateFormat="dd.MM.yyyy"
                  placeholder='TT.MM.JJJJ'
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(Contract.Period.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'Arrivals.Start', row: arrivalKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
              )}
              
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(arrival.End, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  selected={arrival.End}
                  startDate={arrival.Start}
                  endDate={arrival.End}
                  minDate={arrival.Start}
                  dateFormat="dd.MM.yyyy"
                  placeholder='TT.MM.JJJJ'
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(arrival.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'Arrivals.End', row: arrivalKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.mon ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.mon ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'mon', value: !arrival.Weekdays.mon }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.tue ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.tue ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'tue', value: !arrival.Weekdays.tue }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.wed ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.wed ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'wed', value: !arrival.Weekdays.wed }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.thu ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.thu ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'thu', value: !arrival.Weekdays.thu }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.fri ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.fri ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'fri', value: !arrival.Weekdays.fri }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.sat ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.sat ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'sat', value: !arrival.Weekdays.sat }))} />}</Table.Cell>
            <Table.Cell>{readOnly ? <>{arrival.Weekdays.sun ? <Icon circular name='check' /> : <></>}</> : <FormCheckbox toggle checked={arrival.Weekdays.sun ? true : false} onClick={() => dispatch(setContractData({target: 'Arrivals.Weekday', row: arrivalKey,  weekday: 'sun', value: !arrival.Weekdays.sun }))} />}</Table.Cell>
            {!readOnly && (
              <Table.Cell>
                <Button basic circular icon>
                  <Icon name='trash' onClick={() => handleDeleteRow(arrivalKey)} />
                </Button>
                <Button basic circular icon>
                  <Icon name='copy outline' onClick={() => handleCopyRow(arrivalKey)} />
                </Button>
              </Table.Cell>
            )}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    {!readOnly && (
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        Zeile hinzufügen (HeadOffice)
      </Button>
    )}
    </>
  );
}

export default Max2ContractHeadOfficeArrivals;
